module.exports = __webpack_public_path__ + "img/advantage_03.cc172d52.png";